"use client";

import { cn } from "@/lib/utils";
import { CheckCircle2, AlertTriangle, XCircle, Clock, Loader2 } from "lucide-react";

type Status = "success" | "warning" | "error" | "pending" | "running";

const statusConfig: Record<Status, { icon: typeof CheckCircle2; className: string; label: string }> = {
  success: { icon: CheckCircle2, className: "text-accent bg-accent/10", label: "Success" },
  warning: { icon: AlertTriangle, className: "text-amber-600 bg-amber-50", label: "Warning" },
  error: { icon: XCircle, className: "text-destructive bg-destructive/10", label: "Failed" },
  pending: { icon: Clock, className: "text-muted-foreground bg-secondary", label: "Pending" },
  running: { icon: Loader2, className: "text-primary bg-primary/10", label: "Running" },
};

interface StatusBadgeProps {
  status: Status;
  label?: string;
}

const StatusBadge = ({ status, label }: StatusBadgeProps) => {
  const config = statusConfig[status];
  const Icon = config.icon;

  const displayLabel = label ?? config.label;
  const labelContent = typeof displayLabel === "string" ? displayLabel : String(displayLabel ?? "");

  return (
    <span className={cn("inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md text-xs font-medium", config.className)}>
      <Icon className={cn("h-3 w-3", status === "running" && "animate-spin")} />
      {labelContent}
    </span>
  );
};

export default StatusBadge;
